module.exports = __webpack_public_path__ + "static/media/edit.6d9af9b8.svg";